// import axios from "axios";
import firebase from "firebase/app";

export default {
  state: {
    user: {
      name: "",
      position: "",
      phone: "",
      email: "",
      url: "",
      role: ""
    },
    optionsLoad: false,
    options: {
      corps: [],
      facades: [],
      loops: [],
      boxes: [],
      mechanisms: [],
      tabletop: [],
      tabletop_psc: [],
      wall_panel: [],
      wall_panel_psc: [],
      other_list: []
    }
  },
  mutations: {
    setOptionsByName(state, { name, data }) {
      state.options[name] = data;
    },
    setUser(state, data) {
      state.user = data;

      // data.some(item => {
      //   if (item.email === state.user.email) {
      //     state.user = { ...item };
      //     return true;
      //   }
      //   return false;
      // });
    }
  },
  actions: {
    async fetchOptions({ commit }) {
      const fetchInfo = name => {
        return firebase
          .database()
          .ref(`goods/${name}`)
          .once("value")
          .then(res => {
            let list = res.val() ?? [];
            commit("setOptionsByName", { name: name, data: list });
          });
      };

      try {
        await fetchInfo("corps");
        await fetchInfo("facades");
        await fetchInfo("loops");
        await fetchInfo("boxes");
        await fetchInfo("mechanisms");
        await fetchInfo("tabletop");
        await fetchInfo("tabletop_psc");
        await fetchInfo("wall_panel");
        await fetchInfo("wall_panel_psc");
        await fetchInfo("other_list");
      } catch (e) {
        commit("setError", e);
        console.log("e", e);
        throw e;
      }
    },
    // eslint-disable-next-line no-unused-vars
    createUser({ commit, dispatch }, uid) {
      // const uid = firebase.auth().currentUser?.uid;

      firebase
        .database()
        .ref(`users/${uid}`)
        .set({
          name: "name",
          position: "position",
          phone: "phone",
          email: "email",
          url: "url",
          role: "user"
        })
        .then(() => {
          dispatch("fetchUserInfo");
        });
    },
    // eslint-disable-next-line no-unused-vars
    fetchUserInfo({ commit, dispatch }) {
      const uid = firebase.auth().currentUser?.uid;

      return firebase
        .database()
        .ref(`users/${uid}`)
        .once("value")
        .then(res => res.val())
        .then(res => {
          if (res) {
            commit("setUser", res);
          } else {
            dispatch("createUser", uid);
          }
        });
    }
  },
  getters: {
    getOptions: state => state.options,
    manager: state => {
      return state.user;
    }
  }
};
